import {
  ColumnSettings,
  ColumnTypes,
  TableCellURLType,
  TableFilterType,
} from '@app/sharedModule/models/table-settings.model';
import { TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';
import { TrackService } from '@pages/workspace/track/services/track.service';
import { CarrierProvidersNames } from '@pdqdev/pdq-shared/dist/CarrierData';

export const DROPDOWN_OPTIONS_FIELD = 'dropdownOptionsProp';
export interface DropdownOption {
  value: any;
  text: string;
}

export const columnsConfigs: ColumnSettings[] = [
  {
    type: ColumnTypes.CHECKBOX,
    prop: 'checkbox',
    hideColumnName: true,
    sortable: false,
    withFulfillmentIcon: true,
    width: 70,
    minWidth: 70,
    maxWidth: 70,
  },
  {
    type: ColumnTypes.COLOR,
    prop: 'colorCoding',
    name: 'Color coding',
    filterType: TableFilterType.COLOR,
    filterOption: 'IN',
    filterValueArray: [],
    sortDirection: null,
    width: 70,
    minWidth: 70,
    maxWidth: 120,
    canBeHide: true,
    default: true,
  },
  {
    type: ColumnTypes.TEXT,
    sortable: true,
    prop: 'orderNumber',
    name: 'Order no.',
    width: 50,
    minWidth: 50,
    withLoyalty: true,
    filterOption: 'LIKE',
    filterValue: '',
    filterType: TableFilterType.TEXT,
    split: true,
    merged: true,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'externalOrderNumber',
    name: 'External order number',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'shippingAddressFormatted',
    name: 'Ship to',
    width: 150,
    minWidth: 150,
    maxWidth: 150,
    withNote: true,
    type: ColumnTypes.POPOVER_COLUMN,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['customer.ordersCount'],
    withLoyalty: true,
    default: true,
    canBeHide: true,
  },
  {
    prop: 'shippingAddress.province',
    name: 'Ship to state',
    width: 120,
    minWidth: 120,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'shippingAddress.country',
    name: 'Ship to country',
    width: 140,
    minWidth: 140,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'customerFormated',
    name: 'Bill to',
    width: 90,
    minWidth: 90,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    sortFieldName: ['customer.firstName'],
    canBeHide: true,
    default: false,
  },
  {
    type: ColumnTypes.TEXT,
    sortable: true,
    prop: 'itemCount',
    name: 'Items',
    filterOption: 'IN',
    filterValue: '',
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    default: true,
    canBeHide: true,
    internalStatus: true,
  },
  {
    type: ColumnTypes.TEXT,
    sortable: true,
    prop: 'deliveryTransaction.shippingPriceAmount',
    name: 'Shipping cost',
    filterFields: 'shippingPriceAmount',
    filterOption: 'LIKE',
    filterValue: '',
    width: 70,
    minWidth: 70,
    sortFieldName: ['shippingPriceAmount'],
    filterType: TableFilterType.TEXT,
    default: true,
    canBeHide: true,
  },
  {
    type: ColumnTypes.TEXT,
    prop: 'deliveryTransaction.metadata.insurance.insuranceFee',
    name: 'Insurance fee',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.EMPTY,
    default: true,
    canBeHide: true,
  },
  {
    type: ColumnTypes.TEXT,
    sortable: true,
    prop: 'deliveryTransaction.shippingId',
    name: 'Tracking number',
    filterFields: 'shippingId',
    filterOption: 'LIKE',
    filterValue: '',
    width: 70,
    minWidth: 70,
    sortFieldName: ['shippingId'],
    filterType: TableFilterType.TEXT,
    linkType: TableCellURLType.DELIVERY_TRACKING_URL,
    default: true,
    canBeHide: true,
  },
  {
    type: ColumnTypes.FULFILLMENT,
    sortable: true,
    prop: 'fulfillmentStatus',
    name: 'Fulfillment status',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: TranslatedFulfillmentStatus.FULFILLED,
        text: 'Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.PARTIALLY_FULFILLED,
        text: 'Partially Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.NOT_FULFILLED,
        text: 'Unfulfilled',
      },
    ],
    filterOption: 'LIKE',
    sortDirection: '',
    default: true,
    canBeHide: true,
  },
  {
    prop: 'totalTagsCount',
    name: 'Tags',
    type: ColumnTypes.POPOVER_COLUMN,
    width: 80,
    minWidth: 80,
    maxWidth: 80,
    filterType: TableFilterType.TAGS,
    filterOption: 'IN',
    filterValue: '',
    filterValueArray: [],
    sortDirection: '',
    tooltipText: 'View all tags',
    scrollSection: 'orderTagsId',
    zeroStateText: 'tag',
    default: true,
    canBeHide: true,
  },
  {
    prop: 'deliveryTransaction.translatedShippingStatus',
    filterFields: 'deliveryTransaction.shippingStatus',
    name: 'Delivery status',
    type: ColumnTypes.SHIPPING_STATUS,
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.SELECT,
    filterOption: 'IN',
    sortDirection: '',
    filterSelectOptions: TrackService.getShippingStatusFilterOptions(),
    default: true,
    canBeHide: true,
  },
  {
    prop: 'box.name',
    name: 'Package name',
    filterType: TableFilterType.SELECT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['box.name'],
    filterSelectOptions: [],
  },
  {
    prop: 'skus',
    name: `SKUs`,
    filterType: TableFilterType.TEXT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['skus'],
    tooltipText: 'View all skus',
    scrollSection: 'orderDetailsId',
    zeroStateText: 'SKU',
  },
  {
    prop: 'deliveryMethod',
    name: 'Delivery method',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    default: false,
    canBeHide: true,
  },
  {
    prop: 'maximalShippingHours',
    name: 'Service level',
    type: ColumnTypes.TEXT,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: '<= 1',
        text: 'under 1 day',
      },
      {
        value: '<= 2',
        text: 'under 2 days',
      },
      {
        value: '<= 3',
        text: 'under 3 days',
      },
      {
        value: '<= 4',
        text: 'under 4 days',
      },
      {
        value: '<= 5',
        text: 'under 5 days',
      },
      {
        value: '> 5',
        text: 'over 5 days',
      },
    ],
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    type: ColumnTypes.TEXT,
    sortable: true,
    prop: 'orderShipmentFee',
    name: 'Charge for shipping',
    width: 70,
    minWidth: 70,
    canBeHide: true,
    default: false,
  },
  {
    prop: 'recommendedCarrierProviders',
    name: 'Preferred carrier',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.SELECT,
    filterOption: 'LIKE',
    filterSelectOptions: [
      {
        value: CarrierProvidersNames.FEDEX,
        text: 'Fedex',
      },
      {
        value: CarrierProvidersNames.USPS,
        text: 'USPS',
      },
      {
        value: CarrierProvidersNames.UPS,
        text: 'UPS',
      },
    ],
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'selectedCarrierName',
    name: 'Delivery service',
    width: 175,
    minWidth: 175,
    filterType: TableFilterType.SELECT,
    filterOption: 'LIKE',
    sortDirection: '',
    sortFieldName: ['orderBatch'],
    canBeHide: true,
    default: false,
  },
  {
    type: ColumnTypes.DELIVERY_PROMISE,
    sortable: true,
    prop: 'deliveryPromise',
    name: 'Delivery promise',
    width: 190,
    minWidth: 190,
    maxWidth: 250,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    sortFieldName: ['deliveryDate'],
    filterFields: 'deliveryDate',
  },
];
